import Vue from 'vue'
import VueRouter from 'vue-router'
import Landing from "@/views/Landing/Landing"

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Landing
  }
]

const router = new VueRouter({
  routes
})

export default router
